var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('news-list'),_c('hr'),_c('dpo-request'),_c('hr'),_c('crime-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }